import React, { JSX } from 'react';

import { ItemComponentProps } from '../../../Models/ItemRegistry';
import { Placeholder } from '../../Components/Util/Placeholder/Placeholder';

const List = (props: ItemComponentProps): JSX.Element => {
  const { item } = props;
  return <Placeholder>Placeholder for {item.name}</Placeholder>;
};
export default List;
